import styles from './playerControllerWrapper.module.scss'
import SvgComponent from "../../../../components/icons/forYou/InfoIcon";
import React from "react";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../store/store";
import {Link, useNavigate} from "react-router-dom";
import {ROUTES} from "../../../../constants/routes";

const AdsBottomMenu = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const userEmail = useAppSelector((state: any) => state.auth.userData.email);


  return (
    <div className={styles.bottomMenuAds}>
      <div className={styles.holder}>
        <SvgComponent />
        <div className={styles.textWrapper}>{t('ads1')} <Link to={ROUTES.DISCOUNT}>{t('ads2')}</Link></div>
      </div>
      <button
        type="button"
        onClick={() => {
          if (userEmail) {
            navigate(ROUTES.DISCOUNT);
          } else {
            navigate(ROUTES.LOGIN);
          }
        }}
        className={styles.subsBtn}
      >
        {t('ads3')}
      </button>
    </div>
  )
};

export default AdsBottomMenu;
